import React from 'react'
import dayjs from 'dayjs'
import { Client } from '../../../../pure-js/types/GrooverTypes'
import type { WalkInReceiptItem } from '../../../../pure-js/libs/getWalkInReceiptItems'
import { ReceiptCard, RefundedPill } from './PortalWalkinTicketsPage.styles'

interface PortalWalkinTicketCardProps {
  item: WalkInReceiptItem
  client: Client | null
  getText: (key: string) => string
  onClick: () => void
}

const formatAmount = (cents: number, currency: string): string => {
  return `${(cents / 100).toFixed(2)} ${currency}`
}

export const PortalWalkinTicketCard: React.FC<PortalWalkinTicketCardProps> = ({ item, client, getText, onClick }) => {
  const { payment, activity, refundedCents } = item
  const isRefunded = refundedCents > 0 && refundedCents >= payment.totalAmount
  const isPartiallyRefunded = refundedCents > 0 && refundedCents < payment.totalAmount
  const currency = (payment.currency as string) || 'SEK'
  const dateStr = payment.paymentDate ? dayjs(payment.paymentDate).format('D MMM YYYY') : '—'

  return (
    <ReceiptCard
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#111827', flex: 1, minWidth: 0, marginRight: 8 }}>
          {activity.name}
        </div>
        {(isRefunded || isPartiallyRefunded) && (
          <RefundedPill>
            {isRefunded ? getText('portalWalkinRefunded') : getText('portalWalkinPartiallyRefunded')}
          </RefundedPill>
        )}
      </div>
      {client && <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 6 }}>{client.name}</div>}
      <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 4 }}>{dateStr}</div>
      <div style={{ fontWeight: 600, fontSize: 16, color: '#111827' }}>
        {formatAmount(payment.totalAmount, currency)}
      </div>
    </ReceiptCard>
  )
}
